module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre13",
    attrs: {
      "id": "pgepubid00002"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('table', {
    staticClass: "calibre14",
    attrs: {
      "summary": ""
    }
  }, [_c('tbody', {
    staticClass: "calibre15"
  }, [_c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  })]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    staticClass: "gutsmall"
  }, [_vm._v("PAGE")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Antwerp to Boom")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00003"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0005#page1"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("On the Willebroek Canal")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00004"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0006#page8"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Royal Sport Nautique")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00005"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0007#page16"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("At Maubeuge")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0008#page25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("On the Sambre Canalised: to\nQuartes")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0009#page33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Pont-sur-Sambre")]), _vm._v(":")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("We are\nPedlars")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010#page42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Travelling\nMerchant")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010#page51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("On the Sambre Canalised: to\nLandrecies")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0011#page59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("At Landrecies")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0012#page67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Sambre and Oise Canal: Canal\nboats")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0013#page75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Oise in Flood")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00013"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0014#page83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Origny Sainte-Benoîte")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("A By-day")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0015#page95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Company at\nTable")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00015"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0015#page105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Down the Oise: to Moy")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00016"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0016#page116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("La Fère of Cursed\nMemory")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00017"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0017#page124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Down the Oise: Through the Golden\nValley")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00018"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0018#page133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Noyon Cathedral")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00019"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0019#page137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Down the Oise: to\nCompiègne")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00020"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0020#page145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Changed Times")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00021"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0022#page157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("157")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Down the Oise: Church\ninteriors")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00022"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0023#page167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("167")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Précy and the\nMarionnettes")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00023"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0024#page177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("177")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre16"
  }, [_c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Back to the world")])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre17"
  }, [_c('p', {
    staticClass: "calibre19"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00024"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0025#page194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("194")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0